import { SET_STRIKER_BY_TOURNAMENT } from "../constans";

const initialState = {
    strikersByTournament: [],
}


function strikerPlayer(state = initialState, action) {
switch (action.type) {
    case SET_STRIKER_BY_TOURNAMENT:
        return {...state, strikersByTournament: action.payload};

    default:
        return initialState;
}

}

export default strikerPlayer